import React from "react";

const Contact = () => {
  return <div>CONTACT PAGE</div>;
};

export default Contact;
